// extracted by mini-css-extract-plugin
export default {"saveBtn":"TermsAndConditions_saveBtn__PYThn","privacyPolicy":"TermsAndConditions_privacyPolicy__JA94D"};